import { PlatformEnum } from '@/enums/PlatformEnum'
import httpClient from './HttpClient'
import { PlatformTypeEnum } from '@/enums/PlatformTypeEnum'
import GeneralService from './GeneralService'
import { useGeneralStore } from '@/stores/general'
import { useResourcesStore } from '@/stores/resource'
import { storeToRefs } from 'pinia'



interface LoginCredentials {
    email: string
    password: string
    remember?: boolean
}

interface User {
    id: number
    name: string
    email: string
    roles?: Array<{ name: string }>
}

export default {
    async login(credentials: LoginCredentials) {
        const payload = {
            email: credentials.email,
            password: credentials.password,
            remember_me: credentials.remember,
            platform_id: PlatformEnum.ID_DROPOFF,
            platform_type: PlatformTypeEnum.TYPE_WEB,
        }

        try {   
            await GeneralService.auth()
            const response = await httpClient.post('/auth', payload)
            return response
        } catch (error) {
            throw error
        }
    },

    logout() {
        return httpClient.delete('/auth')
    },

    async getUser(): Promise<{ data: User }> {
        console.log('getUser - calling GeneralService.init()')
        const response = await GeneralService.init()   
        console.log('response general api ',response) 
        if(response.data.resourceHash){

            const {resourceHash} = storeToRefs(useGeneralStore())
            resourceHash.value = response.data.resourceHash as string

            //setup cdn
            if(resourceHash){
                useResourcesStore().setupCdn(resourceHash.value)
            }


        }
        
        console.log('getUser - init response:', response)
        return { data: response.data.user }
    },

    ping() {
        return httpClient.get('/auth/ping')
    },

    async validateGoogleToken(data: { access_token?: string, google_one_tap_credential?: string, socialite_token?: string }) {
        await GeneralService.auth()
        return httpClient.post('/auth/sso/google/validate-access-token', {
            ...data,
            platform_id: PlatformEnum.ID_DROPOFF,
        })
    },

    async loginViaGoogle() {
        return httpClient.get(`/auth/sso/google/redirect/${PlatformEnum.ID_DROPOFF}`)
    },
}